import React, { Component } from 'react';
import intl from 'react-intl-universal';
import { getParameterByName } from '../../querystring.js';

const locales = {
    'pt-BR': require('../../locales/pt-BR.json'),
    'en-US': require('../../locales/en-US.json'),
    'es-ES': require('../../locales/es-ES.json')
  };

class Navbar extends Component {

    constructor() {
        super();

        const querystring = getParameterByName('lang');

        console.log(querystring)

        const language = querystring ? querystring : navigator.language;
    
        const currentLocale = locales[language] ? language : 'pt-BR';
    
        intl.init({
          currentLocale,
          locales
        });
      }

    render() {
        return (
                 <div>
                    <nav className="navbar navbar-default navbar-fixed-top topnav" role="navigation">
                        <div className="container topnav">
                            <div className="navbar-header">
                                <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
                                    <span className="sr-only">Toggle navigation</span>
                                    <span className="icon-bar"></span>
                                    <span className="icon-bar"></span>
                                    <span className="icon-bar"></span>
                                </button>
                                <a className="navbar-brand topnav" href="https://track.co/" target="_blank" rel="noopener noreferrer">
                                    <img src="/imgs/logo.png" alt="Calculadora NPS" />
                                </a>
                            </div>
                            <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
                                <ul id="navbar-left" className="nav navbar-nav navbar-lef">
                                    <li>
							            <a href="https://track.co/" target="_blank" rel="noopener noreferrer">{intl.get('menu.tracksale')}</a>
						            </li>
                                    <li>
							            <a href="https://track.co/blog" target="_blank" rel="noopener noreferrer">{intl.get('menu.satisfação')}</a>
						            </li>
                                    {/* <li className="dropdown lang_dropdown">
                                        <a href="#" className="dropdown-toggle" id="language" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">{intl.get('menu.seleção')} <span className="caret"></span></a>
                                        <ul className="dropdown-menu">
                                            <li><a className="lang" href="?lang=es-ES" role="button" id="page-language">{intl.get('menu.espanhol')} <img src="https://tracksale.co/site/images/es.png" alt="Espanhol" width="18" height="12" /></a></li>
                                            <li><a className="lang" href="?lang=en-US" role="button" id="page-language">{intl.get('menu.inglês')} <img src="https://tracksale.co/site/images/en.png" alt="Inglês" width="18" height="12" /></a></li>
                                            <li><a className="lang" href="?lang=pt-BR" role="button" id="page-language">{intl.get('menu.português')} <img src="https://tracksale.co/site/images/pt_br.png" alt="Português" width="18" height="12" /></a></li>
                                        </ul>
                                    </li> */}
                                </ul>
                            </div>
                        </div>
                    </nav>
                </div>
        );

    }
}

export default Navbar;


